import m, {Vnode} from "mithril";
import {Questionary} from "../../model/questionary";
import {Answer} from "./Battery";

export default class BatteryCard {

    private onAnimationFinish: (()=>void)|null = null;
    private animation: string|null = null;

    public progress: null|{current: number, total: number} = null;

    public readonly self: BatteryCard;

    public imageUrl = '';

    constructor(
        public question: string,
        public readonly answers: Answer[],
        private readonly questionary: Questionary,
        private readonly onClick: (()=>void)|null = null,
    ) {
        this.self = this;
    }

    public makeAnimation(animation: string, onFinish: (()=>void)|null = null) {
        this.animation = animation;
        this.onAnimationFinish = onFinish;
        m.redraw();
    }


    private getAnswerText(): string|null {
        for (const answer of this.answers) {
            if (answer.radio.isChecked()) {
                return this.questionary.renderText(answer.label);
            }
        }
        return null;
    }

    public isAnswered(): boolean {
        return this.answers.every(answer => answer.radio.cell.validate().valid);
    }

    private onAnimationEnd() {
        this.self.animation = null;
        if (this.self.onAnimationFinish) {
            this.self.onAnimationFinish();
            this.self.onAnimationFinish = null;
        }
    }

    view(): Vnode {
        return m('.card-wrapper', {}, [
            m('.card.shape', {}, [
                m('.card-body', {}, [
                    m('p', {}, m.trust(this.getAnswerText() || '')),
                ]),
            ]),
            m('.card' + (this.animation !== null ? '.'+this.animation : ''), {
                onclick: this.onClick ? this.onClick : undefined,
                onanimationend: this.onAnimationEnd.bind(this),
            }, [
                m('.card-body', {}, [
                    this.imageUrl ? m('img', {draggable: false, src: this.imageUrl}) : null,
                    m('p', {}, m.trust(this.questionary.renderText(this.question)))
                ]),
                this.progress ? m('.progress', {}, `${this.progress.current} / ${this.progress.total}`) : null,
            ])
        ]);
    }



}
